const COMMON = {
    NO_INTERNET: 'Sin conexión a internet, reconectando…',
    ERROR_TITLE: 'Opps',
    ERROR_MESSAGE: 'Al parecer tu conexión falló.',
    RETRY_MESSAGE: 'Por favor vuelve a intentar.',
    YEAR: 'Año',
    MONTH: 'Mes',
    DAY: 'Día',
    HOUR: 'Hora',
    MINUTE: 'Minuto',
    RETRY: 'Reintentar',
    FILE_TYPE_NOT_ALLOWED: 'Formato de archivo no permitido',
    FILE_SIZE_NOT_ALLOWED: 'Tamaño de archivo no permitido',
    MOTORFY_LABEL: 'Motorfy',
    VER_MAS: 'Ver más...',
    VER_MENOS: 'Ver menos...'
};

const DATA_LAYER = {
    QUOTE: 'Cuotas',
    QUOTE_TURBO_CASH: 'CotizacionTurbo',
    SEND_QUOTE_TURBO_CASH: 'SolicitudTurboEnviada',
    DENIED_BUREAU_TURBO_CASH: 'BuroDenegadoTyCR',
    LOGIN: 'Login',
    APPLICANT: 'DatosSolicitante',
    PRIVACY: 'Privacidad',
    NIP: 'NipIdentidad',
    HOME: 'Domicilio',
    BUREAU: 'Buro',
    NIP_BUREAU: 'NipBuro',
    VALIDATION_SUCCESS: 'ValidacionExitosa',
    VALIDATION_DENIED: 'ValidacionDenegada',
    BUREAU_ERROR: 'BuroError',
    BUREAU_QUESTIONS: 'BuroPreguntas',
    WORK: 'Laboral',
    REFERENCES: 'Referencias',
    INSURANCE: 'Seguro',
    UPLOAD_DOCUMENTS: 'CargaDocumentos',
    FINISHED: 'Finalizada',
    FUNDED: 'Financiado',
    CASH: 'Contado'
};

export {
    COMMON,
    DATA_LAYER
};